<template>
  <Quote :content="value" />
</template>

<script>
export default {
  name: "ControlApolloGridQuoteEditor",
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
};
</script>
